var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { ButtonAFY, variants, sizes, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { themeCore } from "../../../assets/themes/theme";
import { printCertificateQuote } from "../../../resources/helperAPAP/certificatesQuote";
import { URLs } from "../../../resources/url";
import { getHeaderNotification } from "../../../resources/headers";
var PassengerDownloadModalComponent = function (_a) {
    var open = _a.open, onClose = _a.onClose, setSeeToast = _a.setSeeToast, quoteId = _a.quoteId, onOpenPdf = _a.onOpenPdf, policyNumber = _a.policyNumber, planName = _a.planName, sponsor = _a.sponsor;
    // Removed useStyles to prevent style re-injection flickering
    // const classes = useStyles();
    var _b = useState(""), passengerName = _b[0], setPassengerName = _b[1];
    var _c = useState(""), passengerEmail = _c[0], setPassengerEmail = _c[1];
    var _d = useState(""), nameError = _d[0], setNameError = _d[1];
    var _e = useState(""), emailError = _e[0], setEmailError = _e[1];
    var _f = useState(false), isSending = _f[0], setIsSending = _f[1];
    var validateEmail = function (email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    var isFormValid = passengerName.trim().length > 0 && validateEmail(passengerEmail);
    var handleClose = React.useCallback(function () {
        setPassengerName("");
        setPassengerEmail("");
        setNameError("");
        setEmailError("");
        onClose();
    }, [onClose]);
    var handlePassengerDownload = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, response, doc, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isValid = true;
                    if (!passengerName.trim()) {
                        setNameError("El nombre es requerido");
                        isValid = false;
                    }
                    else {
                        setNameError("");
                    }
                    if (!passengerEmail.trim()) {
                        setEmailError("El correo electrónico es requerido");
                        isValid = false;
                    }
                    else if (!validateEmail(passengerEmail)) {
                        setEmailError("Por favor ingrese un correo electrónico válido");
                        isValid = false;
                    }
                    else {
                        setEmailError("");
                    }
                    if (!isValid) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, printCertificateQuote(quoteId, "QUICK_PRINT")];
                case 2:
                    response = _a.sent();
                    if (response && response.success) {
                        if (response.data && response.data.length > 0) {
                            doc = response.data[0];
                            onOpenPdf(doc, doc.name || "");
                        }
                        else {
                            showToastSuccessMessage("No se encontró documento para descargar.", typeAlert.warning, setSeeToast);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error downloading certificate:", error_1);
                    showToastSuccessMessage("Error al descargar el documento.", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [passengerName, passengerEmail, handleClose, setSeeToast, quoteId, onOpenPdf]);
    var handleSendEmail = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, printResponse, attachmentUrl, body, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isValid = true;
                    if (!passengerName.trim()) {
                        setNameError("El nombre es requerido");
                        isValid = false;
                    }
                    else {
                        setNameError("");
                    }
                    if (!passengerEmail.trim()) {
                        setEmailError("El correo electrónico es requerido");
                        isValid = false;
                    }
                    else if (!validateEmail(passengerEmail)) {
                        setEmailError("Por favor ingrese un correo electrónico válido");
                        isValid = false;
                    }
                    else {
                        setEmailError("");
                    }
                    if (!isValid) return [3 /*break*/, 6];
                    setIsSending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, printCertificateQuote(quoteId, "QUICK_PRINT")];
                case 2:
                    printResponse = _a.sent();
                    attachmentUrl = printResponse && printResponse.success && printResponse.data && printResponse.data.length > 0
                        ? printResponse.data[0]
                        : null;
                    body = {
                        to: passengerEmail,
                        name: passengerName,
                        type: "policy",
                        subject: "Sus documentos de cotización",
                        policyNumber: policyNumber || quoteId,
                        plan: planName || "",
                        sponsor: sponsor || "",
                        includeAttachments: !!attachmentUrl,
                        attachments: attachmentUrl ? [{ href: attachmentUrl }] : [],
                    };
                    return [4 /*yield*/, fetch(process.env.REACT_APP_HOST_API + URLs.notificationsSend, {
                            method: "POST",
                            headers: getHeaderNotification(),
                            body: JSON.stringify(body),
                        })];
                case 3:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    showToastSuccessMessage("Cotización enviada por correo electrónico", typeAlert.success, setSeeToast);
                    handleClose();
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    console.error("Error sending email:", error_2);
                    showToastSuccessMessage("Error al enviar el correo electrónico.", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 6];
                case 5:
                    setIsSending(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [passengerName, passengerEmail, handleClose, setSeeToast, quoteId, policyNumber, planName, sponsor]);
    var handleNameChange = React.useCallback(function (e) {
        var value = e.target.value;
        setPassengerName(value);
        if (value.trim())
            setNameError("");
    }, []);
    var handleEmailChange = React.useCallback(function (e) {
        var value = e.target.value;
        setPassengerEmail(value);
        if (value.trim())
            setEmailError("");
    }, []);
    var handleDownloadConditions = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var pdfPath, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    showToastSuccessMessage("Descargando condiciones generales...", typeAlert.success, setSeeToast);
                    pdfPath = "/assets/Condiciones_Generales.pdf";
                    return [4 /*yield*/, fetch(pdfPath)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    onOpenPdf("/assets/Condiciones_Generales.pdf", "Condiciones Generales");
                    handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error("Error downloading conditions:", error_3);
                    showToastSuccessMessage("Error al descargar el archivo. Por favor, intente nuevamente.", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [handleClose, setSeeToast]);
    // Inline styles to avoid JSS flickering
    var styles = {
        title: {
            fontSize: "24px",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "20px",
        },
        components: {
            justifyContent: "center",
            width: "100%",
            clear: "both",
        },
        component: {
            width: "100%",
            marginBottom: "15px",
        },
        label: {
            fontSize: "14px",
            marginBottom: "5px",
            fontWeight: "bold",
        },
        input: {
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "16px",
            boxSizing: "border-box",
        },
        inputError: {
            borderColor: "#d32f2f",
        },
        errorText: {
            color: "#d32f2f",
            fontSize: "0.75rem",
            marginTop: "4px",
        },
        buttonsContainer: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
            gap: "10px",
        },
        button: {
            flex: 1,
            padding: "10px",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "14px",
        },
    };
    return (_jsx("div", __assign({ style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300, // High z-index to be on top
        }, onClick: handleClose }, { children: _jsxs("div", __assign({ onClick: function (e) { return e.stopPropagation(); }, style: {
                backgroundColor: "#ffffff",
                padding: "40px",
                minWidth: "450px",
                borderRadius: "0px",
                boxShadow: "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
                position: "relative",
            } }, { children: [_jsx("button", __assign({ onClick: handleClose, style: {
                        position: "absolute",
                        top: "12px",
                        right: "12px",
                        background: "none",
                        border: "none",
                        fontSize: "20px",
                        cursor: "pointer",
                        lineHeight: 1,
                        color: "#666",
                    }, "aria-label": "Cerrar" }, { children: "\u2715" })), _jsx("h2", __assign({ style: styles.title }, { children: "Descargar Cotizaci\u00F3n de Seguro de Viaje" })), _jsxs("div", __assign({ style: styles.components }, { children: [_jsxs("div", __assign({ style: styles.component }, { children: [_jsx("div", __assign({ style: styles.label }, { children: "Nombre y Apellido" })), _jsx("input", { value: passengerName, placeholder: "Ingrese su nombre completo", onChange: handleNameChange, style: __assign(__assign({}, styles.input), (nameError ? styles.inputError : {})) }), nameError && (_jsx("div", __assign({ style: styles.errorText }, { children: nameError })))] })), _jsxs("div", __assign({ style: styles.component }, { children: [_jsx("div", __assign({ style: styles.label }, { children: "Correo electr\u00F3nico" })), _jsx("input", { value: passengerEmail, placeholder: "ejemplo@correo.com", onChange: handleEmailChange, style: __assign(__assign({}, styles.input), (emailError ? styles.inputError : {})) }), emailError && (_jsx("div", __assign({ style: styles.errorText }, { children: emailError })))] }))] })), _jsxs("div", __assign({ style: styles.buttonsContainer }, { children: [_jsx("div", { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Descargar cotizaci\u00F3n", onClick: handlePassengerDownload, fullWidth: true, backgroundColor: themeCore.colors.primary, disabled: !isFormValid || isSending }) }), _jsx("div", { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: isSending ? "Enviando..." : "Enviar", onClick: handleSendEmail, fullWidth: true, backgroundColor: themeCore.colors.primary, disabled: !isFormValid || isSending }) })] }))] })) })));
};
export var PassengerDownloadModal = React.memo(PassengerDownloadModalComponent);
